export const AUTH_STORAGE_KEY = 'ce.auth.user';
export const AUTH_REMEMBER_ME = 'ce.auth.remember_me';

export const AuthValidationRules = {
  NAME: {
    required: true
  },
  EMAIL: {
    required: true,
    email: true
  },
  PASSWORD_ENTER: {
    required: true,
    password: true
  },
  NEW_PASSWORD: {
    required: true,
    password: true
  },
  CONFIRM_PASSWORD: {
    required: true,
    confirm: ['@password']
  }
};
